'use client';

import { Heading } from '@depop/web-thrift-ui/Typography';
import clsx from 'clsx';

import styles from './styles.module.css';

type QuizOptionCardProps = {
  imageSrc: string;
  imageSrcMobile?: string;
  imageAlt: string;
  label: string;
  labelId: string;
  labelPosition: 'top-left' | 'bottom-center';
};

export function QuizOptionCard({
  imageSrc,
  imageSrcMobile,
  imageAlt,
  label,
  labelId,
  labelPosition,
}: QuizOptionCardProps) {
  const imageContent = (
    <>
      {imageSrcMobile && (
        <source media="(max-width: 767px)" srcSet={imageSrcMobile} />
      )}
      <img src={imageSrc} alt={imageAlt} className={styles.image} />
    </>
  );

  return (
    <div aria-hidden="true" className={styles.container}>
      {imageSrcMobile ? (
        <picture className={styles.picture}>{imageContent}</picture>
      ) : (
        imageContent
      )}
      <div
        className={clsx(styles.labelOverlay, {
          [styles['top-left']]: labelPosition === 'top-left',
          [styles['bottom-center']]: labelPosition !== 'top-left',
        })}
      >
        <Heading
          id={labelId}
          variant="sm"
          as="p"
          className={styles.label}
          aria-hidden="true"
        >
          {label}
        </Heading>
      </div>
    </div>
  );
}
